class Global {
  constructor(Vue, store) {
    this.$vue = Vue;
    this.store = store;
  }
  // vue 객체 초기화전에 작업
  async build() {
    //await this.getRoleJurisdiction();
    await this.createUserMenuTree();
    return Promise.resolve();
  }
  /*getRoleJurisdiction() {
    this.store.dispatch("getUserFunctions");
  }*/
  createUserMenuTree() {
    this.store.dispatch("createUserMenuTree");
  }
}
export default Global;
